import React from 'react';
import { LANGSAM_TEXT } from '../../lib/cobrowse';

const FARBE = { gut: '#34d399', mittel: '#e0b56a', langsam: '#f43f5e' };
const TEXT = { gut: 'Gute Verbindung', mittel: 'Mittlere Verbindung', langsam: 'Langsame Verbindung' };

export const NetzBalken = ({ netz }) => {
  const st = netz?.stufe;
  const aktiv = { gut: 3, mittel: 2, langsam: 1 }[st] || 0;
  return (
    <span className="inline-flex items-center gap-2" data-testid="cobrowse-netz" data-stufe={st || 'messung'} title={st ? TEXT[st] : 'Verbindung wird gemessen'}>
      <span className="inline-flex items-end gap-[2px] h-3.5">
        {[1, 2, 3].map((i) => <span key={i} className="w-[3px] rounded-sm transition-colors duration-300" style={{ height: `${i * 33}%`, background: i <= aktiv ? FARBE[st] : 'rgba(255,255,255,0.2)' }} />)}
      </span>
      <span className="font-mono text-[11px]" style={{ color: st ? FARBE[st] : 'rgba(255,255,255,0.5)' }} data-testid="cobrowse-netz-ms">
        {netz?.stumm ? 'keine Antwort' : netz?.ms != null ? `${netz.ms} ms` : 'misst …'}
      </span>
      {st === 'langsam' && <span className="text-[11px] text-rose-300" data-testid="cobrowse-netz-hinweis">{LANGSAM_TEXT}</span>}
    </span>
  );
};

export const NetzPunkt = ({ netz }) => {
  const st = netz?.stufe;
  if (!st) return null;
  return (
    <span className="inline-flex items-center gap-1.5 shrink-0" data-testid="cobrowse-netz-punkt" data-stufe={st} title={`${TEXT[st]}${netz.ms != null ? ` (${netz.ms} ms)` : ''}`}>
      <span className="w-2 h-2 rounded-full" style={{ background: FARBE[st] }} />
      {st === 'langsam' && <span className="text-[10px] text-rose-300 hidden sm:inline" data-testid="cobrowse-netz-punkt-hinweis">{LANGSAM_TEXT}</span>}
    </span>
  );
};
